import { z } from 'zod';
import { employeeRangeSchema } from './employeeRange.js';
export const updateCompanyProfileSchema = z.object({
    companyName: z.string().max(255),
    description: z.string().max(999).optional(),
    street: z.string().trim().min(1).max(255),
    nr: z.string().trim().min(1).max(30),
    city: z.string().max(100).optional(),
    postcode: z.string().max(4).optional(),
    website: z.string().max(255).optional(),
    employees: employeeRangeSchema.optional(),
});
